<template>
  <span class="user-menu d-flex ml-auto">
    <v-menu
      v-model="menuOpen"
      :persistent="false"
      location="bottom"
      :offset="[0, 4]"
      class="rounded-lg"
      transition="slide-y-transition"
      :attach="true"
    >
      <template #activator="{ props }">
        <Button
          v-bind="props"
          color=""
          text
          elevation="0"
          class="text-primary"
        >
          <v-tooltip
            v-if="emailNotVerified"
            location="left"
          >
            <template #activator="{ props: tooltipProps }">
              <v-icon
                v-bind="tooltipProps"
                start
                color="red"
                size="x-small"
              >
                mdi-alert-circle-outline
              </v-icon>
            </template>
            <span>{{ $t("Account not verified yet.") }}</span>
          </v-tooltip>
          <v-icon
            start
            size="small"
            style="top: 2px;"
          >
            mdi-account-circle-outline
          </v-icon>
          <div class="user-name">{{ userProfile?.firstName || '' }} {{ userProfile?.lastName || '' }}</div>
          <v-icon end>mdi-chevron-down</v-icon>
        </Button>
      </template>

      <v-list>
        <v-list-item
          link
          @click="profile"
        >
          <v-list-item-title>{{ $t("My Profile") }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          link
          @click="logout"
        >
          <v-list-item-title>{{ $t("Logout") }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </span>
</template>

<script lang="ts" setup>
import { ref, computed, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import Button from '@/components/input-components/Button.vue'
import type { User } from '@/entities/user'
import { PermissionsService } from '@/services/permissions.service'
import { useMyProfileUiStore } from '@/stores/myProfileUi'
import { useProfileStore } from '@/stores/profile'

const profileStore = useProfileStore()
const userProfile = computed((): Partial<User> => profileStore.profile)

const instance = getCurrentInstance()
const keycloak = instance?.appContext.config.globalProperties.$keycloak


const permissionsService = new PermissionsService(keycloak)
const myProfileUiStore = useMyProfileUiStore()
const router = useRouter()

const hasRoleExternalUser = computed(() => permissionsService.hasRoleExternalUser)
const hasRoleCegatVerified = computed(() => permissionsService.hasRoleCegatVerified)
const emailNotVerified = computed(() => hasRoleExternalUser.value && !hasRoleCegatVerified.value)

const menuOpen = ref(false)

function logout(): void {
  keycloak?.logout()
}

function profile(): void {
  if (router.currentRoute.value.path === '/MyProfile') {
    myProfileUiStore.resetTab()
  } else {
    router.push({path: '/MyProfile'})
  }
}
</script>

<style lang="scss">
.user-menu {
  min-width: fit-content;
  align-items: center;

  .user-name {
    font-size: 1.125rem;
  }

  button {
    letter-spacing: 1px;
    background-color: transparent;

    .btn-hover-bg {
      color: var(--v-theme-primary);
      background-color: transparent;
      transition: background-color 0.3s ease;

      &:hover {
        background-color: rgba(var(--v-theme-header-bg), var(--v-main-opacity));
      }
    }

    .v-btn__overlay {
      background-color: rgba(var(--v-theme-primary), var(--v-hover-opacity)) !important;
    }

    @media #{map.get($display-breakpoints, 'xs-only')} {
      //&.v-btn:not(.v-btn--round).v-size--x-large {
      &.v-btn.v-btn--size-x-large {
        padding-left: 1rem;
        padding-right: 1rem;
      }
    }
  }
}
</style>
